'use strict';
const angular = require('angular');

export class accordionWidgetComponent {

  constructor(SettingsService, DynamicPageService) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.DynamicPageService = DynamicPageService;
  }

  $onInit() {

    this.closeOthers = this.closeOthers == 'true';

    this.SettingsService.getByName({name: this.settings}, setting => {
      let sections = setting.data;

      sections.forEach(section => {
        if (!section.content) {
          this.DynamicPageService.getByName({name: section.page}, page => {
            section.content = this.convertShortcode(page.data);
          })
        } else {
          section.content = this.convertShortcode(section.content);
        }
      });

      this.sections = sections;

    }, err => {
      console.log('could not retrieve setting');
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduuApp.accordionWidget', [])
  .component('accordionWidget', {
    template: require('./accordion-widget.component.html'),
    bindings: {
      settings: '@',
      closeOthers: '@'
    },
    controller: accordionWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/accordion-widget/accordion-widget.component.js